import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import StorefrontIcon from '@material-ui/icons/Storefront';

const lojinhaRouteRef = createRouteRef();

const lojinhaPage = PageBlueprint.make({
  params: {
    path: '/lojinha',
    title: 'Lojinha',
    icon: <StorefrontIcon fontSize="inherit" />,
    noHeader: true,
    routeRef: lojinhaRouteRef,
    loader: async () => {
      const { LojinhaPage } = await import('./LojinhaPage');
      return <LojinhaPage />;
    },
  },
});

export const lojinhaPlugin = createFrontendPlugin({
  pluginId: 'lojinha',
  title: 'Lojinha',
  icon: <StorefrontIcon fontSize="inherit" />,
  routes: {
    root: lojinhaRouteRef,
  },
  extensions: [lojinhaPage],
});
